import * as qz from 'qz-tray';
import store from "../../store/store";

const SCALE_RESPONSE_TIMEOUT_MS = 3000;

export function parseScaleWeight(response){
  const rawResponse = response === null || typeof response === 'undefined' ? '' : response.toString();
  const weightMatch = rawResponse.match(/(-?\d+(?:\.\d+)?)\s*(LB|OZ|KG|G)/i);

  if (!weightMatch) return null;

  const weight = parseFloat(weightMatch[1]);
  if (isNaN(weight)) return null;

  return weight.toFixed(3);
}

export async function sendToScales(saveResult){
  const terminal = store.getters['config/terminal'];
  const connectOptions = terminal.printer_server_ip?{...{host: terminal.printer_server_ip}}:{};

  if(!qz.websocket.isActive()){
    await qz.websocket.connect(connectOptions).then(function(){
    }).catch(function(e){
      console.error('Can not connect to qz tray', e);
      throw e;
    });
  }

  const port = terminal.scale?terminal.scale:'COM1';
  let hasCloseStarted = false;

  const properties = {
    start: '',
    end: '',
    width: null,
    baudRate: 9600,
    dataBits: 8,
    stopBits: 1,
    parity: 'NONE',
    flowControl: 'NONE',
    encoding: 'ASCII'
  };

  const closePort = function(){
    if (hasCloseStarted) return Promise.resolve();
    hasCloseStarted = true;
    return qz.serial.closePort(port).catch(function(err){
      console.error(err);
    });
  };

  await qz.serial.openPort(port, properties);

  let responseBuffer = '';
  let timeoutId = null;
  let isSettled = false;

  const responsePromise = new Promise(function(resolve, reject){
    const settle = function(callback){
      if (isSettled) return;
      isSettled = true;
      clearTimeout(timeoutId);
      closePort();
      callback();
    };

    timeoutId = setTimeout(function(){
      settle(function(){
        reject(new Error('No scale weight response received'));
      });
    }, SCALE_RESPONSE_TIMEOUT_MS);

    qz.serial.setSerialCallbacks(function(streamEvent){
      if (streamEvent.type === 'ERROR'){
        console.error(streamEvent.exception);
        settle(function(){
          reject(streamEvent.exception);
        });
        return;
      }

      responseBuffer += streamEvent.output ? streamEvent.output.toString() : '';
      const parsedWeight = parseScaleWeight(responseBuffer);
      if (!parsedWeight) return;

      saveResult(parsedWeight);
      settle(function(){
        resolve(parsedWeight);
      });
    });
  });

  const serialData = {
    data: 'W\r',
    type: 'PLAIN'
  };

  try{
    await qz.serial.sendData(port, serialData, properties);
    await responsePromise;
  } catch(e){
    clearTimeout(timeoutId);
    await closePort();
    throw e;
  }
}
